/* =====================================================================
   AE • PRODUCT (PDP) — JS EXTERNALISÉ (sans Liquid)
   - Variants: update variant id + price + main image
   - Sur-mesure URL pré-remplie
   - Cart ajax + ouverture drawer
   - Zoom-pan (transform-origin sous la souris)
   - Mobile dots
   - Lightbox robuste (anti-thème) + navigation flèches + croix active
===================================================================== */

(() => {
  const qsa = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  function parseJSON(el, fallback = {}) {
    try { return JSON.parse(el?.textContent || '') || fallback; }
    catch (e) { return fallback; }
  }

  function toLarge(src) {
    if (!src) return '';
    if (src.includes('width=')) return src.replace(/width=\d+/g, 'width=2400');
    if (/_\d+x/.test(src)) return src.replace(/_\d+x/g, '_2400x');
    return src;
  }

  function canOpenDrawer() {
    const drawer = document.querySelector('cart-drawer#cart-drawer') || document.getElementById('cart-drawer');
    if (!drawer) return false;

    if (typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }

    if (typeof drawer.show === 'function') {
      drawer.show();
      return true;
    }

    drawer.setAttribute('open', '');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open', 'drawer--open');
    document.documentElement.classList.add('no-scroll');
    document.body.classList.add('no-scroll');
    return true;
  }

  async function addToCartAjax(form) {
    const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

    const res = await fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: new FormData(form)
    });

    if (!res.ok) throw new Error('cart/add failed ' + res.status);
    return res.json();
  }

  async function getCart() {
    const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

    const res = await fetch(ROOT + 'cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!res.ok) return null;
    return res.json().catch(() => null);
  }

  function dispatchCartEvents(cart) {
    const detail = cart ? { cart } : {};

    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { detail }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail }));

    document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { detail }));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail }));

    document.documentElement.dispatchEvent(new CustomEvent('cart:change', { detail }));
    document.dispatchEvent(new CustomEvent('cart:change', { detail }));
  }

  /* =========================
     LIGHTBOX
  ========================= */

  function initLightbox(section, mosaic) {
    const SECTION_ID = section.getAttribute('data-section-id') || '';
    const LB_ID = 'aeLightbox-' + SECTION_ID;

    let lb = document.getElementById(LB_ID);
    if (!lb) {
      lb = document.createElement('div');
      lb.className = 'ae-lightbox';
      lb.id = LB_ID;
      lb.setAttribute('aria-hidden', 'true');
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-label', 'Agrandissement image');
      lb.innerHTML = `
        <div class="ae-lb__inner" role="document">
          <button class="ae-lb-close" type="button" aria-label="Fermer">×</button>
          <button class="ae-lb-nav ae-lb-prev" type="button" aria-label="Précédent">‹</button>
          <img class="ae-lb-img" alt="Agrandissement" />
          <button class="ae-lb-nav ae-lb-next" type="button" aria-label="Suivant">›</button>
        </div>
      `;
      document.body.appendChild(lb);
    }

    const img = lb.querySelector('.ae-lb-img');
    const prev = lb.querySelector('.ae-lb-prev');
    const next = lb.querySelector('.ae-lb-next');
    const close = lb.querySelector('.ae-lb-close');
    const inner = lb.querySelector('.ae-lb__inner');

    function getUrls() {
      let list = [];
      try {
        list = JSON.parse(mosaic.getAttribute('data-ae-urls') || '[]') || [];
      } catch (e) {
        list = [];
      }

      const out = [];
      const seen = new Set();

      list.forEach((u) => {
        const lu = toLarge((u || '').trim());
        if (!lu) return;
        if (seen.has(lu)) return;
        seen.add(lu);
        out.push(lu);
      });

      if (out.length) return out;

      const cells = Array.from(mosaic.querySelectorAll('.ae-cell'))
        .sort((a, b) => parseInt(a.dataset.idx || '0', 10) - parseInt(b.dataset.idx || '0', 10));

      return cells.map((cell) => {
        const im = cell.querySelector('img');
        const s = im ? ((im.currentSrc || im.src || '').trim()) : '';
        return toLarge(s);
      }).filter(Boolean);
    }

    let urls = getUrls();
    let idx = 0;

    function isOpen() {
      return lb.getAttribute('aria-hidden') === 'false';
    }

    function syncNav() {
      const multi = urls.length > 1;
      if (prev) prev.classList.toggle('is-disabled', !multi);
      if (next) next.classList.toggle('is-disabled', !multi);
    }

    function render() {
      if (!urls.length) return;
      idx = (idx + urls.length) % urls.length;
      img.src = urls[idx];
      syncNav();
    }

    function openAt(i) {
      urls = getUrls();
      if (!urls.length) return;

      idx = Number.isFinite(i) ? i : 0;
      idx = (idx + urls.length) % urls.length;

      lb.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('ae-lb-open');
      document.body.classList.add('ae-lb-open');

      render();

      try {
        close && close.focus({ preventScroll: true });
      } catch (e) {}
    }

    function closeLb() {
      lb.setAttribute('aria-hidden', 'true');
      img.removeAttribute('src');
      document.documentElement.classList.remove('ae-lb-open');
      document.body.classList.remove('ae-lb-open');
    }

    function go(delta) {
      if (!urls.length) return;
      idx = idx + delta;
      render();
    }

    mosaic.addEventListener('click', (e) => {
      const cell = e.target.closest('.ae-cell');
      if (!cell || !mosaic.contains(cell)) return;
      const i = parseInt(cell.dataset.idx || '0', 10);
      openAt(Number.isFinite(i) ? i : 0);
    });

    if (!lb.dataset.aeStopBubble) {
      lb.dataset.aeStopBubble = 'true';

      ['click', 'pointerdown', 'mousedown', 'touchstart'].forEach((evt) => {
        lb.addEventListener(evt, (e) => {
          if (!isOpen()) return;
          e.stopPropagation();
        }, false);
      });
    }

    prev && prev.addEventListener('click', (e) => {
      e.preventDefault();
      go(-1);
    });

    next && next.addEventListener('click', (e) => {
      e.preventDefault();
      go(+1);
    });

    close && close.addEventListener('click', (e) => {
      e.preventDefault();
      closeLb();
    });

    lb.addEventListener('click', (e) => {
      if (!isOpen()) return;
      if (inner && inner.contains(e.target)) return;
      closeLb();
    });

    if (!lb.dataset.aeKeys) {
      lb.dataset.aeKeys = 'true';

      document.addEventListener('keydown', (e) => {
        if (!isOpen()) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          closeLb();
        }
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          go(-1);
        }
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          go(+1);
        }
      }, true);
    }

    syncNav();
  }

  /* =========================
     DOTS mobile
  ========================= */

  function initDots(section, mosaic) {
    const dotsWrap = section.querySelector('[data-ae-dots]');
    if (!dotsWrap) return;

    const cells = Array.from(mosaic.querySelectorAll('.ae-cell'));
    dotsWrap.innerHTML = '';

    const dots = cells.map((cell, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'ae-dot' + (i === 0 ? ' is-active' : '');
      b.setAttribute('aria-label', 'Voir l’image ' + (i + 1));

      b.addEventListener('click', () => {
        const offset = cell.offsetLeft - (mosaic.clientWidth - cell.clientWidth) / 2;
        mosaic.scrollTo({ left: offset, behavior: 'smooth' });
      });

      dotsWrap.appendChild(b);
      return b;
    });

    function updateDotsOnScroll() {
      const center = mosaic.scrollLeft + mosaic.clientWidth / 2;
      let closestIndex = 0;
      let closestDist = Infinity;

      cells.forEach((cell, i) => {
        const cellCenter = cell.offsetLeft + cell.clientWidth / 2;
        const dist = Math.abs(cellCenter - center);
        if (dist < closestDist) {
          closestDist = dist;
          closestIndex = i;
        }
      });

      dots.forEach((d, i) => d.classList.toggle('is-active', i === closestIndex));
    }

    mosaic.addEventListener('scroll', () => requestAnimationFrame(updateDotsOnScroll));
    updateDotsOnScroll();
  }

  /* =========================
     ZOOM PAN
  ========================= */

  function initZoomPan(section) {
    const pointerFine = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
    if (!pointerFine) return;

    qsa('.ae-cell', section).forEach((cell) => {
      const img = cell.querySelector('.ae-img');
      if (!img) return;

      cell.addEventListener('mousemove', (e) => {
        const r = cell.getBoundingClientRect();
        const x = ((e.clientX - r.left) / r.width) * 100;
        const y = ((e.clientY - r.top) / r.height) * 100;
        const cx = Math.max(0, Math.min(100, x));
        const cy = Math.max(0, Math.min(100, y));
        img.style.transformOrigin = `${cx}% ${cy}%`;
      });

      cell.addEventListener('mouseleave', () => {
        img.style.transformOrigin = '50% 50%';
      });
    });
  }

  /* =========================
     VARIANTS + CTA + CART
  ========================= */

  function initVariantsAndCTA(section) {
    const P = parseJSON(section.querySelector('[data-ae-product-json]'), {});
    const variants = P.variants || [];

    const form = section.querySelector('#aeProductForm');
    const idInput = section.querySelector('#aeVariantId');
    const priceEl = section.querySelector('[data-price]');
    const addBtn = section.querySelector('[data-add-to-cart]');
    const smBtn = section.querySelector('[data-sm-btn]');
    const sizeSelect = section.querySelector('#aeSizeSelect');

    const smMode = section.getAttribute('data-sm-mode') || 'auto';
    const isModeleVendu = section.getAttribute('data-is-modele-vendu') === 'true';
    const isMasquerPrix = section.getAttribute('data-is-masquer-prix') === 'true';
    const smBaseUrl = (section.getAttribute('data-sm-base-url') || '/pages/sur-mesure');

    function selectedOptionsByIndex() {
      const sel = {};

      qsa('.ae-chips', section).forEach((g) => {
        const i = parseInt(g.dataset.optIndex, 10);
        const c = g.querySelector('input:checked');
        if (!isNaN(i) && c) sel[i] = c.value;
      });

      return sel;
    }

    function selectedOptionByName(name) {
      if (!name) return '';
      const wanted = (name + '').trim().toLowerCase();
      const groups = qsa('.ae-chips', section);

      for (const g of groups) {
        const n = (g.dataset.optName || '').trim().toLowerCase();
        if (!n) continue;
        if (n === wanted) {
          const c = g.querySelector('input:checked');
          return c ? c.value : '';
        }
      }

      return '';
    }

    function findVariant() {
      const sel = selectedOptionsByIndex();

      return variants.find((v) => {
        if (!v || !Array.isArray(v.options)) return false;
        return v.options.every((val, i) => (sel[i] || '') === val);
      }) || variants[0];
    }

    function updateMainImageForVariant(v) {
      const mainImg = section.querySelector('[data-main-img]');
      if (!mainImg) return;

      if (!mainImg.dataset.baseSrc) {
        mainImg.dataset.baseSrc = mainImg.getAttribute('src') || '';
      }

      const baseSrc = mainImg.dataset.baseSrc;

      const variantSrc =
        (v && v.featured_image && (v.featured_image.src || v.featured_image.url)) ||
        (v && v.featured_media && v.featured_media.preview_image && (v.featured_media.preview_image.src || v.featured_media.preview_image.url)) ||
        '';

      mainImg.setAttribute('src', variantSrc || baseSrc);
    }

    function updateSmVisibility(isUnavailable) {
      if (!smBtn) return;

      let showSm = false;
      if (smMode === 'always') showSm = true;
      else if (smMode === 'never') showSm = false;
      else showSm = isMasquerPrix || isModeleVendu || isUnavailable;

      smBtn.hidden = !showSm;
      smBtn.setAttribute('aria-hidden', showSm ? 'false' : 'true');
    }

    function getDisplayedAttr(kind) {
      const el = section.querySelector('[data-attr-value="' + kind + '"]');
      return el ? (el.textContent || '').trim() : '';
    }

    function buildSmUrl(v) {
      if (!smBtn) return;

      const taille =
        (sizeSelect && sizeSelect.value) ? sizeSelect.value :
        (section.querySelector('.ae-attr-fixed--size .ae-attr-value')
          ? (section.querySelector('.ae-attr-fixed--size .ae-attr-value').textContent || '').trim()
          : '');

      const matOpt =
        selectedOptionByName('Métal') ||
        selectedOptionByName('Metal') ||
        selectedOptionByName('Matière') ||
        selectedOptionByName('Matiere');

      const pierreOpt = selectedOptionByName('Pierre') || selectedOptionByName('Pierres');

      const matiere = (matOpt || getDisplayedAttr('matiere'));
      const pierre = (pierreOpt || getDisplayedAttr('pierre'));

      const u = new URL(smBaseUrl, window.location.origin);
      u.searchParams.set('produit', P.title || '');
      if (taille) u.searchParams.set('taille', taille);
      if (matiere) u.searchParams.set('matiere', matiere);
      if (pierre) u.searchParams.set('pierre', pierre);
      if (v && v.id) u.searchParams.set('variant', String(v.id));

      smBtn.setAttribute('href', u.toString());
    }

    function updateUI() {
      const v = findVariant();

      if (idInput && v) idInput.value = v.id;

      if (priceEl && v && !isMasquerPrix) {
        if (typeof v.price === 'number') {
          priceEl.textContent = (v.price / 100).toFixed(2).replace('.', ',') + ' €';
        }
      }

      const isUnavailable = !v || !v.available;
      if (addBtn) addBtn.disabled = !!isUnavailable;

      updateSmVisibility(isUnavailable);
      updateMainImageForVariant(v);
      buildSmUrl(v);
    }

    qsa('.ae-chips input', section).forEach((r) => r.addEventListener('change', updateUI));
    sizeSelect && sizeSelect.addEventListener('change', updateUI);

    updateUI();

    if (form) {
      form.addEventListener('submit', async (e) => {
        const submitter = e.submitter;
        if (submitter && (submitter.name === 'checkout' || submitter.hasAttribute('data-buy-now'))) return;
        if (!addBtn) return;

        e.preventDefault();

        try {
          await addToCartAjax(form);

          let cart = await getCart();
          if (!cart || typeof cart.item_count !== 'number') {
            await new Promise((r) => setTimeout(r, 150));
            cart = await getCart();
          }

          dispatchCartEvents(cart);
          setTimeout(() => { canOpenDrawer(); }, 0);
        } catch (err) {
          console.error('[AE add-to-cart] error:', err);
          try { form.submit(); } catch (e2) {}
        }
      });
    }
  }

  function initSection(section) {
    const mosaic = section.querySelector('.ae-mosaic');

    if (mosaic) {
      initLightbox(section, mosaic);
      initDots(section, mosaic);
    }

    initZoomPan(section);
    initVariantsAndCTA(section);
  }

  function boot() {
    qsa('[data-ae-product]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();